import type { BotAppearance } from 'types';

export const BOTS_HOST_URL = 'https://bots.easy-peasy.ai';

// Inbound-only domain for bot email addresses; its MX points at Postmark,
// which forwards mail to the bots server inbound webhook
export const BOT_EMAIL_DOMAIN = 'agents.easy-peasy.ai';

/** What chat.min.js paints the launcher when `data-widget-btn-color` is absent. */
export const DEFAULT_WIDGET_BUTTON_COLOR = '#6366f1';

const HEX_COLOR = /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;

/**
 * The colour an agent's chat window is branded with, for its launcher button:
 * the header colour when one is set, else the bot bubble colour — the same
 * fallback the widget header itself uses. Agents created from a website carry
 * their brand colour in the header, with a neutral bot bubble.
 *
 * The launcher never reads the appearance, so an install snippet without this
 * colour shows the default indigo bubble whatever the agent looks like.
 */
export const agentAccentColor = (
  appearance?: Pick<
    BotAppearance,
    'chat_header_style' | 'chat_bot_bubble_style'
  > | null,
) =>
  [
    appearance?.chat_header_style?.background_color,
    appearance?.chat_bot_bubble_style?.background_color,
  ]
    .find(
      (value): value is string =>
        typeof value === 'string' && HEX_COLOR.test(value.trim()),
    )
    ?.trim()
    .toLowerCase() || DEFAULT_WIDGET_BUTTON_COLOR;
